import React from 'react';
import PropTypes from 'prop-types';
import { useSessionContext } from 'utils/session/sessionContext';
import BaseRoute from './BaseRoute';

const UnloggedRoute = ({ children, ...rest }) => {
  const { isLoggedIn } = useSessionContext();
  return (
    <BaseRoute userCheckCallback={() => !isLoggedIn} redirectPath="/" {...rest}>
      {children}
    </BaseRoute>
  );
};

UnloggedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UnloggedRoute;
